(function() {
  var AccessController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  exports.ManageUsersController = (function(superClass) {
    extend(ManageUsersController, superClass);

    function ManageUsersController(scope, transitions, modal, service1, window, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.service = service1;
      this.window = window;
      this.http = http;
      this.loadUsers = bind(this.loadUsers, this);
      this.deleteUser = bind(this.deleteUser, this);
      this.changeActivity = bind(this.changeActivity, this);
      this.editContactInfo = bind(this.editContactInfo, this);
      this.viewAccountInfo = bind(this.viewAccountInfo, this);
      this.editRoles = bind(this.editRoles, this);
      ManageUsersController.__super__.constructor.call(this, 'manage_users', this.http);
      this.scope.title = 'Manage Users';
      this.scope.fullpage = true;
      this.scope.displayedCollection = [];
      this.scope.viewAccountInfo = this.viewAccountInfo;
      this.scope.editContactInfo = this.editContactInfo;
      this.scope.changeActivity = this.changeActivity;
      this.scope.editRoles = this.editRoles;
      this.scope.deleteUser = this.deleteUser;
      this.loadUsers();
      this.scope.refreshMeh = (function(_this) {
        return function() {
          angular.element(_this.window).trigger('resize');
        };
      })(this);
    }

    ManageUsersController.prototype.editRoles = function(user) {
      var dlg, newscope;
      newscope = this.scope.$new(true);
      newscope.user = user;
      return dlg = this.modal.open({
        scope: newscope,
        windowClass: 'modal-width',
        templateUrl: 'backend/admin/new-tools/manage-users/edit-roles-layout',
        controller: 'Tools.Controllers.EditRolesController',
        resolve: {
          'roles': [
            'Tools.Services.ManageUsersService', (function(_this) {
              return function(service) {
                return service.editRoles(user.id);
              };
            })(this)
          ]
        }
      });
    };

    ManageUsersController.prototype.viewAccountInfo = function(user) {
      var dlg, newscope;
      newscope = this.scope.$new(true);
      newscope.user = user;
      return dlg = this.modal.open({
        scope: newscope,
        windowClass: 'modal-width',
        templateUrl: 'backend/admin/new-tools/manage-users/view-account-info-layout',
        controller: 'Tools.Controllers.ViewAccountInfoController',
        resolve: {
          'account': [
            'Tools.Services.ManageUsersService', (function(_this) {
              return function(service) {
                return service.viewAccountInfo(user.id);
              };
            })(this)
          ]
        }
      });
    };

    ManageUsersController.prototype.editContactInfo = function(user) {
      var dlg;
      dlg = this.modal.open({
        windowClass: 'modal-width',
        templateUrl: 'backend/admin/new-tools/manage-users/edit-contact-info-layout',
        controller: 'Tools.Controllers.EditContactInfoController',
        resolve: {
          'contact': [
            'Tools.Services.ManageUsersService', (function(_this) {
              return function(service) {
                return service.editContactInfo(user.id);
              };
            })(this)
          ]
        }
      });
      return dlg.result.then((function(_this) {
        return function() {
          return _this.loadUsers();
        };
      })(this));
    };

    ManageUsersController.prototype.changeActivity = function(id, activate) {
      return this.service.changeActivity(id, activate).then((function(_this) {
        return function(response) {
          _this.setAlert(response);
          return _this.loadUsers();
        };
      })(this));
    };

    ManageUsersController.prototype.deleteUser = function(user) {
      var dlg, newscope;
      newscope = this.scope.$new(true);
      newscope.user = user;
      dlg = this.modal.open({
        scope: newscope,
        windowClass: 'modal-width',
        templateUrl: 'backend/admin/new-tools/manage-users/delete-user-layout',
        controller: 'DialogController'
      });
      return dlg.result.then((function(_this) {
        return function() {
          return _this.service.deleteUser(user.id).then(function(response) {
            _this.setAlert(response);
            return _this.loadUsers();
          });
        };
      })(this));
    };

    ManageUsersController.prototype.loadUsers = function() {
      return this.loadScopeData(this.service.getUsers(), 'users').then((function(_this) {
        return function() {
          angular.element(_this.window).trigger('resize');
          return true;
        };
      })(this));
    };

    return ManageUsersController;

  })(AccessController);

}).call(this);
